import { liveSearch, LiveSearchDispatch } from './live-search';

export interface JobSearchParams {
    query?: string;
    /** post code or 'city, state/province/region' */
    location?: string;
    country?: string;
    /** default: relevance */
    sort?: 'relevance' | 'date' | 'distance';
    /** number of days */
    age?: number;
    /** km */
    radius?: number;
    /** page size, max 20 */
    limit?: number;
    cursor?: number;
    highlight?: boolean;
    /** required by Indeed */
    userip?: string;
    /** required by Indeed */
    useragent?: string;
    timestamp?: number;
}

export interface JobSearchResponse {

}

export interface JobPosting {
    id: string;
    title: string;
    snippet: string;
    url: string;
    sponsored: boolean;
    timestamp: number;
    company: {
        name: string;
    };
    address: {
        street?: string;
        city: string;
        state: string;
        country: string;
        // status?: string; // scraped, places_failed, places_success, user, advertiser
    };
    location: {
        latitude: number;
        longitude: number;
        status?: number;
    };
    // eg: indeed_clk(this,'3182')
    onmousedown?: string;
    expired?: boolean;
    rating?: number;
    // source: string;
    // apply: boolean
}



export function jobSearch(profileId: string, params: JobSearchParams, dispatch: LiveSearchDispatch<JobPosting>) {
    params.useragent = navigator.userAgent;

    // console.info('>>>>>>>>>>>>> jobSearch:', profileId, params);
    return liveSearch<JobPosting>('jobs', profileId, params, dispatch);
}
